import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthService, NotificationService } from '@shared/services';
import { ErrorUtils } from '@shared/utils';

import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { AsyncPipe } from '@angular/common';
import { authFeature } from '@store';
import { constants } from '@shared/constants';
import { combineLatest, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-maintenance-page',
  imports: [RktIconComponent, RktButtonDirective, AsyncPipe],
  templateUrl: './maintenance-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './maintenance-page.component.scss',
})
export class MaintenancePageComponent implements OnInit {
  store = inject(Store);
  router = inject(Router);
  authService = inject(AuthService);
  notificationService = inject(NotificationService);

  isAuthenticated$ = this.store.select(authFeature.selectIsLoggedIn);

  isFirstStatusCall = true;

  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.onBackToBusinessAccounts();
  }

  onBackToBusinessAccounts(): void {
    combineLatest([this.store.select(authFeature.selectIsLoggedIn), this.authService.getMaintenanceInfo()])
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: ([authenticated]) => {
          if (!authenticated) {
            this.router.navigateByUrl('/auth');
          } else {
            this.router.navigateByUrl(constants.HOME_ROUTE);
          }
        },
        error: (error) => {
          if (!this.isFirstStatusCall) {
            this.notificationService.displayError('System Maintenance in Progress', 'Error');
            ErrorUtils.catchError('System Maintenance in Progress', error);
          }
          this.isFirstStatusCall = false;
        },
      });
  }
}
